<template>
    <i class="v-icon v-channel" aria-hidden="true" :style="{ fontSize: width + 'px' }"></i>
</template>

<script>
export default {
    props: ['width', 'height']
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Icons/ChannelIcon.vue